import { render, staticRenderFns } from "./HomeMonitorRanking.vue?vue&type=template&id=51971b2c&scoped=true"
import script from "./HomeMonitorRanking.vue?vue&type=script&lang=js"
export * from "./HomeMonitorRanking.vue?vue&type=script&lang=js"
import style0 from "./HomeMonitorRanking.vue?vue&type=style&index=0&id=51971b2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51971b2c",
  null
  
)

export default component.exports